export default {
  //代码里的key(唯一标识): '马来语',
  lang: 'ms',
  appIntroduction: ' Tonton Movie & Drama yang popular pada bila-bila masa ',
  noMoreTip: 'Sudah sampai hujung，tidak ada kandungan lagi~',
  navigator: {
    home: 'Halaman utama',
    all: 'Semua kandungan',
    news: 'Maklumat artikel',
    download: 'Muat turun APP',
    contact: 'Tentang kita',
    joinUs: 'sertai kami'
  },
  seo: {
    title: 'Loklok Watch HD movies online for free',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie, tonton online, tonton percuma, tonton drama percuma, new movies,tv show,Snowdrop,Hotel Transylvania,Encanto,The Silent Sea,Jujutsu Kaisen,9-1-1: Lone Star,Hotel Transylvania,Dragons,SnowdropOur Beloved SummerDemon SlayerHappinessSing 2Ranking of KingsDemon SlayerAttack on TitanTrue BeautyVincenzoAttack on Titan The Final SeasonJujutsu KaisenThe HandmaidenTokyo RevengersNeverthelessItaewon ClassSquid GameCrash Landing on YouEuphoriaAttack on TitanHometown Cha-Cha-Cha',
    description: 'Popular episodes updated quickly,American hot series,Tension, comedy, thriller,Newest hottest dramasall in Loklok',
    ogImage: 'https://static.loklok.video/img/tw-ms.png',
    index: {
      title: 'Loklok - Tonton filem HD dalam talian secara percuma - Syor Filem Tertinggi',
      keywords: 'Loklok, aplikasi Loklok, muat turun loklok, muat turun loklok, loklok pc, apk loklok,  tonton online, tonton percuma, tonton drama percuma,loklok ios, loklok android, loklok untuk ios, loklok untuk android, tv android loklok, loklok chromecast, kdrama, k-drama, drama korea, box office, filem amerika, filem barat, filem blockbuster, filem thailand, filem thai, drama TV, siri TV, anime, animasi, kartun, rancangan pelbagai, yaoi, yuri, bl, gl, hollywood, bollywood, zombie, one piece, naruto, cinta urusan, kita semua mati',
      description: 'Loklok ialah platform penstriman video sehenti untuk anda menonton rancangan TV, filem, animasi dari seluruh dunia! Dengan pelbagai jenis filem eksklusif, anda boleh memilih sari kata berbilang bahasa dan dalam kualiti gambar ultra-HD 4k, filem baharu yang popular dikeluarkan setiap hari!'
    },
    allPage: {
      title: 'Loklok Tonton filem HD dalam talian secara percuma, apa sahaja yang anda boleh bayangkan.',
      keywords: 'Loklok, apl Loklok, muat turun loklok, loklok pc, apk loklok,  tonton online, tonton percuma, tonton drama percuma,animasi,anime,filem blockbuster,episod baharu,filem akan datang, keluaran baharu 2022,tayangan perdana,sci-fi,percintaan manis,komedi,aksi,cinta, filem percuma, percuma filem dalam talian, aplikasi filem percuma, kita semua sudah mati, F4 Thailand: Boys Over Flowers, Euphoria Musim 2, Twenty five twenty one, Ramalan Cinta dan Cuaca,Doktor Hantu, Cantik Sejati,Encanto, Dari,Cadangan Perniagaan,Titisan Salji,Rookie Polis,Masih 2gether',
      description: 'Loklok mempunyai sejumlah besar filem dan kandungan televisyen popular, dan siri dan filem TV terkini dan paling hangat boleh ditonton secara percuma! Kandungan definisi tinggi yang pelbagai, pengalaman pengguna yang diperibadikan dan filem popular semuanya ada di sini.'
    },
    articles: {
      title: 'Loklok Tonton filem HD dalam talian secara percuma, berita terkini loklok',
      keywords: 'Loklok, aplikasi Loklok, muat turun loklok, loklok pc, apk loklok, maklumat filem dan televisyen terkini, cadangan filem, ulasan filem popular, filem dan televisyen 2022, tayangan perdana filem, 2022 patut ditonton, 2022 mesti tonton, 2022 filem pawagam, filem akan datang 2023 , Peaky Blinders Musim 6, serangan ke atas titan musim akhir, musim panas tercinta kami, hotel transylvania 4: transformania, kebahagiaan',
      description: 'Loklok ialah filem popular dan kandungan drama TV boleh ditemui serta-merta, semua jenis filem box office dan carta drama TV dikemas kini dalam masa 24 jam, dan filem dan siri TV popular dipersembahkan dalam masa nyata, datang ke Loklok dan kejar filem anda.'
    },
    download: {
      title: 'Lokok menyediakan muat turun versi rasmi terkini',
      keywords: 'Loklok, aplikasi Loklok, muat turun loklok, loklok pc, apk loklok, tonton online, tonton percuma, tonton drama percuma, muat turun loklok, muat turun loklok, muat turun loklok apk, muat turun loklok ios, muat turun android loklok, loklok googleplay, muat turun loklok pc, loklok versi terkini, laman web rasmi loklok, cara memuat turun Loklok, Loklok desktop, Loklok pad',
      description: 'Muat turun Apl Loklok dan tonton filem dan rancangan TV terkini dalam talian secara percuma pada bila-bila masa, di mana sahaja. Aplikasi loklok mengimbas kod QR tapak web untuk menonton dalam talian pada bahagian PC.'
    },
    search: {

    },
    contact: {
      title: 'Hubungi kami melalui E-mel, Twitter, Facebook, Instagram dan Youtube. - Loklok',
      keywords: 'Twitter, Facebook, Instagram,  tonton online, tonton percuma, tonton drama percuma,Youtube, Contact, E-mail',
      description: 'Soalan mengenai loklok boleh disampaikan melalui e-mel, Twitter, Facebook, Instagram dan Youtube'
    }
  },
  globalTip: {
    emptyTip: 'Sumber semasa tidak dapat dicari',
    searchOther: 'Cuba cari filem atau siri TV lain'
  },
  loginModule: {
    title: 'Log masuk',
    loginMethod: 'Guna loklok APP untuk mengimbas kod QR',
    loginMethodTip: '（Versi perlu dinaik taraf kepada 1.7.0 dan ke atas）',
    howToDownload: 'Cara untuk muat turun loklok',
    clickMe: 'Klik saya',
    loginSuccess: 'Log masuk berjaya',
    loginFailed: 'Log masuk gagal',
    codeExpired: ' Kod QR tamat tempoh！',
    refreshButton: 'Memuatkan semula',
    loginButton: 'Log masuk',
    loginTip: ' Tonton keseluruhan kandungan laman web secara percuma selepas log masuk ',
    logoutButton: 'Log keluar',
    logoutTip: 'Selamat menonton filem!',
    areYouSure: 'Adakah hendak log keluar',
    sure: 'Ya',
    cancel: 'Tidak'
  },
  toTop: {
    downloadApp: 'Muat turun App',
    backToTop: 'Kembali ke bahagian atas'
  },
  indexPage: {
    title: 'LolokTV',
    more: 'Lebih banyak',
    seeMore: 'Lihat lebih banyak'
  },
  searchPage: {
    resultTitle: 'Keputusan Carian:',
    rank: 'Paling Popular di Loklok',
    play: 'Tayangkan',
    popularSearch: 'Carian popular',
    top1: 'Tempat pertama',
    top2: 'Tempat ke-2',
    top3: 'Tempat ke-3',
    top4: 'Tempat ke-4',
    top5: 'Tempat ke-5',
    top6: 'Tempat ke-6',
    top7: 'Tempat ke-7',
    top8: 'Tempat ke-8',
    top9: 'Tempat ke-9',
    top10: 'Tempat ke-10',
    emptyTip: 'Maaf, kita tidak ada kandungan tersebut',
    emptyDesc: 'Cuba cari filem atau rancangan TV lain'
  },
  filterPage: {
    emptyTip: 'Maaf, kita tidak ada kandungan tersebut',
    emptyDesc: 'Cuba cari filem atau rancangan TV lain'
  },
  newsPage: {
    listTitle: 'Maklumat terkini'
  },
  downloadPage: {
    scanQR: ' Imbas kod QR untuk memuat turun App',
    title1: 'Filem & drama popular',
    tip1: 'Tonton secara percuma pada bila-bila masa',
    title2: 'Sari kata berbilang bahasa',
    tip2: 'Drama boleh ditonton secara bebas',
    title3: 'Penyegerakan PC/mudah alih masa nyata'
  },
  detailPage: {
    autoTranslation: 'Terjemahan automatik',
    fiveMiniteTip: 'Hanya 5min, Tonton filem penuh selepas itu',
    loginTip2InDetailPage: 'Guna loklok APP untuk mengimbas kod QR di bawah，tonton kandungan yang berlebihan selepas log masuk',
    category: 'Kategori',
    moreDesc: 'Lebih banyak',
    youMayLike: 'Rancangan yang awak suka',
    relatedSeries: 'Siri berkaitan',
    norelatedSeries: 'Tidak ada siri berkenaan',
    emptyDesc: 'Maaf, kita tidak ada kandungan tersebut',
    emptyTip: 'Maaf, kita tidak ada kandungan tersebut',
    vip: {
      dialog: {
        t1: 'Buka VIP',
        t2: 'Jika anda ingin melihat semua kandungan, sila pergi ke Apl untuk membuka VIP',
        t3: 'App boleh dimuat turun dengan cara berikut',
        t4: 'Sudah mempunyai VIP? Sila <span class="active">klik di sini</span> untuk log masuk',
        t5: 'Sudah mempunyai VIP? Sila <span class="active">muat semula</span> untuk meneruskan menonton',
        t6: 'Anda telah menonton {num} minit, jika anda ingin terus menonton video penuh, sila ke App, atau selepas membuka VIP dalam App, anda boleh terus melayari video'
      },
      player: {
        tip1: 'Anda hanya boleh menonton selama {num} minit. Untuk menonton filem penuh, <span class="active">sila pergi ke apl</span> atau <span class="active">buka VIP</span>'
      },
      episodes: {
        tip1: 'Jadi VIP dan nikmati semua kandungan'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'Pelayar sedang muat turun data',
    NETWORK_NO_SOURCE: 'Sumber audio/video tidak ditemui',
    MEDIA_ERR_ABORTED: 'Proses mendapatkan semula telah dihentikan oleh pengguna',
    MEDIA_ERR_NETWORK: 'Ralat berlaku semasa memuat turun',
    MEDIA_ERR_DECODE: 'Analisis tayangan gagal: Tidak dapat menayangkan fail',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Format audio/video yang tidak disokong',
    REPLAY: 'Tayang semula',
    ERROR: 'Sambungan rangkaian bermasalah',
    PLAY_TIPS: 'Tayangkan',
    PAUSE_TIPS: 'Henti',
    PLAYNEXT_TIPS: 'Episod seterusnya',
    DOWNLOAD_TIPS: 'Muat turun',
    ROTATE_TIPS: 'Putar',
    RELOAD_TIPS: 'Memuatkan semula',
    FULLSCREEN_TIPS: 'Masuk ke skrin penuh',
    EXITFULLSCREEN_TIPS: 'Keluar dari skrin penuh',
    CSSFULLSCREEN_TIPS: 'Masuk ke gaya skrin penuh',
    EXITCSSFULLSCREEN_TIPS: 'Keluar dari gaya skrin penuh',
    TEXTTRACK: 'Sari kata',
    PIP: 'Gambar dalam gambar',
    MINIPLAYER: 'Pemain mini',
    SCREENSHOT: 'Tangkapan skrin',
    LIVE: 'Siaran langsung',
    OFF: 'Tutup',
    MINIPLAYER_DRAG: 'Klik dan tahan untuk menggerakkan video',
    AIRPLAY_TIPS: 'Airplay',
    onlyPlayTip: 'Hanya menayang {msg} minit, log masuk untuk menonton filem penuh ',
    loginTextButton: 'Log masuk',
    replayButton: 'Tayangkan semula',
    nextButton: 'Episod seterusnya',
    refreshButton: 'Memuatkan semula',
    episode: 'Episod'
  },
  contact: {
    business: 'Kerjasama Perniagaan',
    question: 'maklum balas'
  },
  download_nd: {
    desc: 'Tonton sebilangan besar filem dan rancangan TV secara percuma',
    scanQR: 'Imbas kod QR untuk memuat turun aplikasi atau'
  },
  win: {
    feedback: {
      que: ' Penjelasan Soalan Lazim',
      que1: 'Soalan Lazim',
      content: ' Kandungan Maklum Balas',
      contact: 'Maklumat Perhubungan',
      submit: 'Hantar maklum balas',
      tip1: 'Sila berikan penerangan yang terperinci, dan anda juga boleh menyertakan tangkapan skrin yang berkaitan.',
      tip2: 'Sila masukkan emel anda.',
      tip5: 'Saiz gambar yang dimuat naik mesti kurang daripada {num}k.',
      tip6: 'Maksimum 4 gambar boleh dimuat naik.',
      tip3: 'Telah dihantar, sila bersabar.',
      tip4: 'Kandungan maklum balas perlu tidak kurang daripada 10 perkataan.',
      error: 'Ralat Sistem'
    }
  },
  tv: {
    vip: {
      title: 'Sila pilih produk anda',
      tip1: 'Anda boleh melihat kod QR pembayaran selepas log masuk.',
      refresh: 'Segarkan',
      tip2: 'Imbas kod QR untuk pembayaran',
      recharge: 'Perjanjian Pengisian Semula',
      renewal: 'Perjanjian Pembaruan',
      login: 'Log masuk sekarang',
      tip3: 'Lihat selepas log masuk',
      noOpen: 'VIP Standard Belum Diaktifkan',
      gift: 'Hadiah',
      succ: 'Segar berjaya',
      fail: 'Segar gagal',
      day: 'VIP Standard 1 Hari',
      days: 'VIP Standard {x} Hari',
      expiration: 'Masa tamat VIP Standard: {x}',
      expired: 'VIP anda telah tamat tempoh, sila perbaharui segera.',
      interests1: 'Nikmati kualiti HD 1080P',
      interests2: 'Buka semua kandungan',
      interests3: 'Log masuk dari pelbagai peranti'
    }
  }
}